<template>
  <div class="organism-policy_container">
    <div class="organism-policy_body">
      <div class="policy__create">
        <div class="header__title">
          <span v-if="policyAction === 'create'">New Policy</span>
          <span v-else>Edit Policy</span>
        </div>
        <div class="header__container">
          <atom-input
            title="Policy Name"
            :isAsterisk="true"
            placeholder="Policy Name"
            :isError="isErrorCreatePolicyName"
            :errorMessage="errorCreatePolicyName"
            v-model="createPolicy.name"
            :isDisable="createPolicy.name === 'Default Policy' || !hasUpdatePermission"
            class="input__name"
          ></atom-input>
          <atom-input
            title="Description"
            :isAsterisk="true"
            placeholder="Description"
            :isError="isErrorCreatePolicyDescription"
            :errorMessage="errorCreatePolicyDescription"
            v-model="createPolicy.description"
            :isDisable="createPolicy.name === 'Default Policy' || !hasUpdatePermission"
            class="input__description"
          ></atom-input>
        </div>
      </div>

      <div>
        <molecule-list-resource
          :policy="hasUpdatePermission ? policyAction : 'view'"
          :columns="columns"
          :unitList="unitList"
          :isEditPath="mode === 'edit'"
          :isClickApply="isClickApply"
          :isValidateTrigger="isValidateTrigger"
          v-model="currentResourceData"
          @errorInput="errorInResource"
        ></molecule-list-resource>
        <div
          v-if="isClickApply && !completeAtLeastOneRow && hasUpdatePermission"
          class="error__text d-flex align-items-center"
        >
          <feather-icon icon="AlertCircleIcon"></feather-icon>
          <span class="padding-left-5px"
            >Please select at least 1 system resource</span
          >
        </div>
      </div>

      <div v-if="hasUpdatePermission" class="policy__button-right">
        <atom-button
          buttonId="button-apply"
          :isDisable="isDisable"
          @click="clickApply"
          class="button__apply"
        >
          <template>
            <div class="apply__normal">{{ buttonApply }}</div>
            <div class="apply__short">{{ buttonApplyShort }}</div>
          </template>
        </atom-button>

        <atom-button
          v-if="isResourceDataChange"
          buttonId="button-discard"
          buttonStyle="border"
          buttonColor="secondary"
          @click="clickCancel"
          class="button__discard"
        >
          <template>Cancel</template>
        </atom-button>
      </div>
    </div>

    <molecule-modal-dialog
      modalId="modal-confirm-create-policy"
      :isTextCenter="true"
      :textTitle="`Do you want to\ncreate “${createPolicy.name}” ?`"
      buttonTextLeft="Confirm"
      @clickButtonLeft="clickConfirmCreate"
    ></molecule-modal-dialog>

    <molecule-modal-dialog
      modalId="modal-confirm-save-policy"
      :isTextCenter="true"
      :textTitle="`Do you want to save\n“${createPolicy.name}” ?`"
      buttonTextLeft="Confirm"
      @clickButtonLeft="clickConfirmSave"
    ></molecule-modal-dialog>

    <molecule-modal-dialog
      modalId="modal-confirm-cancel-policy"
      :isTextCenter="true"
      :textTitle="`Do you want to leave\nwithout finishing?`"
      buttonTextLeft="Confirm"
      buttonTextRight="Cancel"
      @clickButtonLeft="clickConfirmCancel"
    >
    </molecule-modal-dialog>
  </div>
</template>

<script>
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import MoleculeListResource from "@/components/molecules/serverManagementModule/server/MoleculeListResource.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import { getPolicyManagementUnits } from "@/api/api-module"
import mixins from "@/mixins"
export default {
  name: "OrganismPolicy",
  components: {
    AtomInput,
    AtomButton,
    AtomSwitch,
    AtomSelect,
    MoleculeListResource,
    MoleculeModalDialog,
  },
  mixins: [mixins],
  props: {
    // equipment list when multiple policy edit at server management page.
    equipmentData: {
      type: Object,
      required: false,
      default: () => ({
        isEnable: true,
      }),
    },
    /*
     * list of resource object which contain threshold value
     * (critical:number, warning:number, isEnabled:boolean,
     * resource:string, unit:object => {id:string, name: null !have to map later!})
     */
    resourceData: {
      type: Array,
      required: false,
      default: () => [],
    },
    // value that identify
    isCustom: {
      type: Boolean,
      required: false,
      default: true,
    },
    policyListFromApi: {
      type: Array,
      required: false,
      default: null,
    },
    mode: {
      type: String,
      required: false,
      default: "create",
    },
    hasUpdatePermission: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["clickBack", "clickCreate", "clickSave"],
  data() {
    return {
      isClickApply: false,
      isEnabled: true,
      policyAction: "",
      modalId: "",
      unitList: {
        cpu: [],
        memory: [],
        storage: [],
      },
      policyListAll: [
        { policyName: "Create Policy" },
        { policyName: "Custom Policy" },
        { policyName: "Policy Default" },
      ],
      currentPolicy: { policyName: "Policy Default" },
      selectPolicy: { policyName: "Policy Default" },
      createPolicy: {
        name: "",
        description: "",
      },
      isValidateTrigger: false,
      errorCreatePolicyName: "Please enter name policy",
      errorCreatePolicyDescription: "Please enter description",
      isEdit: false,
      isError: false,
      firstStateNameAndDescription: {
        name: "",
        description: "",
      },
      columns: [
        {
          key: "resource",
          title: "System Resources",
        },
        {
          key: "warning",
          title: "Warning Threshold",
        },
        {
          key: "critical",
          title: "Critical Threshold",
        },
        {
          key: "unit",
          title: "Units",
        },
      ],
      resourceDataOriginal: [
        {
          resource: "CPU",
          warning: "",
          critical: "",
          unit: {
            id: "",
            name: "",
          },
          isEnabled: false,
        },
        {
          resource: "Memory",
          warning: "",
          critical: "",
          unit: {
            id: "",
            name: "",
          },
          isEnabled: false,
        },
        {
          resource: "Storage",
          warning: "",
          critical: "",
          unit: {
            id: "",
            name: "",
          },
          isEnabled: false,
        },
      ],
      currentResourceData: [],
    }
  },
  computed: {
    buttonApply() {
      if (this.policyAction === "create") return "Create New Policy"
      else return "Save Policy"
    },

    buttonApplyShort() {
      if (this.policyAction === "create") return "Create New Policy"
      else return "Save Policy"
    },

    policyList() {
      if (!this.isCustom) {
        this.policyListAll.splice(1, 1)
        return this.policyListAll
      } else return this.policyListAll
    },

    isDisable() {
      if (this.policyAction === "create") {
        if (this.isClickApply) {
          return (
            !this.isNotEmptyString(this.createPolicy.name) ||
            !this.isNotEmptyString(this.createPolicy.description) ||
            !this.completeAtLeastOneRow ||
            this.isError
          )
        }
        return false
      } else if (this.policyAction === "edit") {
        if (!this.isResourceDataChange) {
          return true
        } 
        else {
          return (
            !this.isNotEmptyString(this.createPolicy.name) ||
            !this.isNotEmptyString(this.createPolicy.description) ||
            !this.completeAtLeastOneRow ||
            this.isError
          )
        }
      }
      return true
    },

    completeAtLeastOneRow() {
      let checkChange = false
      this.currentResourceData.forEach((row) => {
        checkChange ||=
          row.isEnabled &&
          this.isNotEmptyString(row.warning) &&
          this.isNotEmptyString(row.critical) &&
          this.isNotEmptyString(row.unit.id)
      })
      return checkChange
    },

    validateIsPolicyDataChange() {
      const nameOrDescriptionChange = this.checkNameOrDescriptionChange()
      const enableResourceDataList = this.getOnlyEnableResourceData()
      const currentResourceData = JSON.parse(JSON.stringify(this.resourceData))
      const sortedEnableResourceDataList = enableResourceDataList.sort((a, b) =>
        a.resource > b.resource ? 1 : -1
      )
      const sortedCurrentResourceData = currentResourceData.sort((a, b) =>
        a.resource > b.resource ? 1 : -1
      )
      const resourceDataChange =
        JSON.stringify(sortedEnableResourceDataList) !==
        JSON.stringify(sortedCurrentResourceData)
      return nameOrDescriptionChange || resourceDataChange
    },

    isResourceDataChange(){
      const currentResourceData = JSON.stringify(this.currentResourceData)
      const resourceDataOriginal = JSON.stringify(this.resourceDataOriginal)
      return currentResourceData !== resourceDataOriginal
    },

    isErrorCreatePolicyName() {
      if (!this.isValidateTrigger) return false
      return this.createPolicy.name ? false : true
    },

    isErrorCreatePolicyDescription() {
      if (!this.isValidateTrigger) return false
      return this.createPolicy.description ? false : true
    },
  },

  watch: {
    currentResourceData: {
      deep: true,
      handler() {
        this.checkEditData()
        if (this.mode === "edit") {
          this.isValidateTrigger = this.isResourceDataChange
        }
      },
    },

    currentPolicy: {
      deep: true,
      handler() {
        this.checkPolicyAction()
      },
    },

    createPolicy: {
      deep: true,
      handler() {
        if (this.isValidateTrigger) {
          this.setIsErrorValue()
        }
        if (this.mode === "edit") {
          this.isValidateTrigger = this.validateIsPolicyDataChange
        }
      },
    },
  },

  async mounted() {
    this.showLoading(true)
    await this.getPolicyManagementUnitsList()
    this.checkPolicyAction()
    /* start loading */
    if (this.policyAction === "edit") {
      this.createPolicy.name = this.equipmentData?.name
      this.createPolicy.description = this.equipmentData?.description
      if (this.resourceData) {
        this.resourceData.forEach((resource) => {
          for (let i = 0; i < this.resourceDataOriginal.length; i++) {
            if (resource.resource === this.resourceDataOriginal[i].resource) {
              this.resourceDataOriginal[i] = resource
            }
          }
        })
      }
    }
    this.saveFirstStateData()
    /* end loading */
  },
  methods: {
    saveFirstStateData() {
      this.currentResourceData = JSON.parse(
        JSON.stringify(this.resourceDataOriginal)
      )
      if (this.mode === "edit") {
        this.firstStateNameAndDescription.name = JSON.parse(
          JSON.stringify(this.equipmentData.name)
        )
        this.firstStateNameAndDescription.description = JSON.parse(
          JSON.stringify(this.equipmentData.description)
        )
      }
    },

    getOnlyEnableResourceData() {
      return this.currentResourceData.filter(
        (resource) => resource.critical && resource.warning && resource.unit.id
      )
    },

    checkNameOrDescriptionChange() {
      return (
        this.firstStateNameAndDescription.name !== this.createPolicy.name ||
        this.firstStateNameAndDescription.description !==
          this.createPolicy.description
      )
    },

    // get policy unit
    getPolicyManagementUnitsList() {
      getPolicyManagementUnits().then((response) => {
        response.forEach((unit) => {
          if (unit.policyResourceTypeName === "CPU") {
            this.unitList.cpu.push({
              id: unit.policyUnitId,
              name: unit.policyUnitName,
            })
          } else if (unit.policyResourceTypeName === "Memory") {
            this.unitList.memory.push({
              id: unit.policyUnitId,
              name: unit.policyUnitName,
            })
          } else if (unit.policyResourceTypeName === "Storage") {
            this.unitList.storage.push({
              id: unit.policyUnitId,
              name: unit.policyUnitName,
            })
          }
        })
        this.showLoading(false)
      })
    },

    checkPolicyAction() {
      this.policyAction = this.mode
    },

    // check data when edit
    checkEditData() {
      let check = false
      for (let i = 0; i < this.currentResourceData.length; i++) {
        check =
          check ||
          JSON.stringify(this.currentResourceData[i]) !==
            JSON.stringify(this.resourceDataOriginal[i])
      }
      this.isEdit = check
    },

    // save change
    clickApply() {
      this.isValidateTrigger = true
      this.$nextTick(() => {
        if (
          !this.isError &&
          !this.isErrorCreatePolicyName &&
          !this.isErrorCreatePolicyDescription &&
          this.completeAtLeastOneRow
        ) {
          this.modalId =
            this.policyAction === "create"
              ? "modal-confirm-create-policy"
              : "modal-confirm-save-policy"
          this.$bvModal.show(this.modalId)
        } else {
          this.isError = true
        }
        this.isClickApply = true
      })
    },

    clickConfirmApply() {
      this.selectPolicy = this.currentPolicy
      this.resourceDataOriginal = JSON.parse(
        JSON.stringify(this.currentResourceData)
      )
      this.closeModal()
      this.isEdit = false
      this.isClickApply = false
      this.$emit("clickBack")
    },

    // click cancel at the bottom of the page
    clickCancel() {
      if (this.isResourceDataChange) {
        this.modalId = "modal-confirm-cancel-policy"
        this.$bvModal.show(this.modalId)
      } else {
        this.$emit("clickBack")
      }
    },

    // click confirm to cancel on modal confirm cancel
    clickConfirmCancel() {
      this.closeModal()
      this.currentResourceData = JSON.parse(
        JSON.stringify(this.resourceDataOriginal)
      )
      this.isEdit = false
      this.isClickApply = false
      this.$emit("clickBack")
    },

    // check error in resource
    errorInResource(error) {
      this.isError = error
    },

    // open confirm enable modal
    onClickSwitchEnabled() {
      this.isEnabled = !this.isEnabled
      this.modalId = "modal-confirm-enable-monitor-event"
      this.$bvModal.show(this.modalId)
    },

    // confirm enable modal
    clickConfirmIsEnabled() {
      this.isEnabled = !this.isEnabled
      this.closeModal()
      this.$emit("clickBack")
    },

    // confirm create modal
    clickConfirmCreate() {
      this.resourceDataOriginal = JSON.parse(
        JSON.stringify(this.currentResourceData)
      )
      this.closeModal()

      let resources = []
      this.resourceDataOriginal.forEach((resource) => {
        if (resource.warning && resource.critical && resource.unit) {
          resources.push({
            resourceName: resource.resource,
            resourceEnable: resource.isEnabled,
            resourceWarningThreshold: parseFloat(resource.warning),
            resourceCriticalThreshold: parseFloat(resource.critical),
            resourceUnitId: resource.unit.id,
          })
        }
      })
      this.$emit("clickCreate", {
        policyName: this.createPolicy.name,
        policyDescription: this.createPolicy.description,
        policyResourceValues: resources,
      })
    },

    // confirm save modal
    clickConfirmSave() {
      this.resourceDataOriginal = JSON.parse(
        JSON.stringify(this.currentResourceData)
      )
      this.closeModal()
      this.isEdit = false

      let resources = []
      this.resourceDataOriginal.forEach((resource) => {
        if (resource.warning && resource.critical && resource.unit) {
          resources.push({
            resourceName: resource.resource,
            resourceEnable: resource.isEnabled,
            resourceWarningThreshold: parseFloat(resource.warning),
            resourceCriticalThreshold: parseFloat(resource.critical),
            resourceUnitId: resource.unit.id,
          })
        }
      })

      this.$emit("clickSave", {
        policyName: this.createPolicy.name,
        policyDescription: this.createPolicy.description,
        policyResourceValues: resources,
      })
    },

    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },

    pushPolicyListAll() {
      this.policyListAll = [...this.policyListAll, ...this.policyListFromApi]
    },

    // Check if text is not blank space or not.
    isNotEmptyString(text) {
      if (text === "") return false
      else return true
    },

    setIsErrorValue() {
      this.isError =
        this.isErrorCreatePolicyName ||
        this.isErrorCreatePolicyDescription ||
        !this.completeAtLeastOneRow
    },
  },
}
</script>

<style lang="scss" scoped>
label {
  margin-bottom: 0;
}

.organism-policy_container {
  width: 100%;
  background-color: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
  padding-bottom: 20px;
}

// body
.organism-policy_body {
  padding: 15px;
  position: relative;
}

// create policy
.header__title {
  color: #5e5873;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 25px;
}
.input__name {
  width: 100%;
}
.input__description {
  width: 100%;
  margin-top: 15px;
}

// button
.policy__button,
.policy__button-right {
  margin-top: 20px;
  margin-bottom: 30px;
}
.policy__button-right {
  display: flex;
  justify-content: flex-end;
}
.button__discard {
  margin-left: 10px;
}
.apply__normal {
  display: none;
}

// modal
.modal-confirm-enable-monitor-event_list,
.modal-confirm-enable-monitor-event__list--full {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.modal-confirm-enable-monitor-event__list {
  width: 216.44px;
}
.modal-confirm-enable-monitor-event__list--full {
  max-width: 100%;
}
.list__ul {
  margin-bottom: 15px;
  padding-left: 16px;
  max-height: 122px;
  overflow-y: auto;
}
.list__title {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 400;
  color: #6e6b7b;
}
.list__title--medium {
  font-weight: 500;
}
.list__li {
  color: #babfc7;
}
.list__label {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 6px;
}

.error__text {
  color: #ea5455;
  font-size: 12px;
  bottom: 5px;
}

.padding-left-5px {
  padding-left: 5px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .organism-policy_container {
    padding-bottom: 10px;
  }
  .organism-policy_body {
    padding: 21px;
  }
  .apply__short {
    display: none;
  }
  .apply__normal {
    display: block;
  }
  // create policy
  .header__container {
    display: flex;
  }
  .input__name {
    width: 324px;
  }
  .input__description {
    margin-top: 0;
    margin-left: 10px;
    width: 428px;
  }

  .modal-confirm-enable-monitor-event__list {
    max-width: 216.44px;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
